import React, { useEffect, useState } from "react";
import { Form, Input, Button, message } from "antd";
import "./Contact.css";
import { User_ContactPost, User_ContactGet } from "../../Api/CoreApi";
import LoginHeader from "../LoginHeader/LoginHeader";
import Footer from "../Footer/Footer";
import {
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
  MessageOutlined,
  HeartFilled,
  SendOutlined,
  SafetyCertificateOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const OnSubmit = async (values) => {
    setLoading(true);
    try {
      await User_ContactPost(values);
      message.success("✅ Message Sent Successfully!");
      form.resetFields();
    } catch (error) {
      message.error("❌ Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchContacts = async () => {
    try {
      const getdata = await User_ContactGet();
      //console.log(getdata);
    } catch (error) {
      //console.error("Error fetching contact data:", error);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  return (
    <>
      <LoginHeader />

      <div className="contact-page">
        {/* Hero / Intro */}
        <section className="contact-hero">
          <div className="contact-hero-overlay"></div>

          <div className="contact-floating-wrap">
            {["💖", "💌", "💕", "🌹", "✨", "❤️", "🎀", "📩"].map((item, index) => (
              <span key={index} className={`contact-float contact-float-${index}`}>
                {item}
              </span>
            ))}
          </div>

          <div className="contact-hero-content">
            <div className="contact-badge">
              <SafetyCertificateOutlined />
              We’re Here to Help
            </div>

            <h1 className="contact-main-title">
              Get In <span>Touch</span>
            </h1>

            <p className="contact-subtitle">
              We’d love to hear from you. Share your questions, feedback, or concerns
              and our team will get back to you with care and support.
            </p>
          </div>
        </section>

        {/* Main Contact Section */}
        <section className="contact-section-wrap">
          <div className="contact-shell">
            {/* Left Info Panel */}
            <div className="contact-info-panel">
              <div className="contact-info-badge">
                <HeartFilled />
                Community Rishtey Support
              </div>

              <h2 className="contact-info-title">
                Let’s Start a <span>Conversation</span>
              </h2>

              <p className="contact-info-text">
                Whether you have a question about profiles, security, privacy,
                or account support — our team is always ready to assist you.
              </p>

              <div className="contact-points">
                <div className="contact-point">
                  <CheckCircleFilled />
                  <span>Quick support and response</span>
                </div>
                <div className="contact-point">
                  <CheckCircleFilled />
                  <span>Safe and confidential communication</span>
                </div>
                <div className="contact-point">
                  <CheckCircleFilled />
                  <span>Friendly guidance from our team</span>
                </div>
              </div>

              <div className="contact-info-cards">
                <div className="contact-info-card">
                  <div className="contact-icon-box">
                    <MailOutlined />
                  </div>
                  <div>
                    <h4>Email Us</h4>
                    <p>communityrishtey@gmail.com</p>
                  </div>
                </div>

                <div className="contact-info-card">
                  <div className="contact-icon-box">
                    <PhoneOutlined />
                  </div>
                  <div>
                    <h4>Call Us</h4>
                    <p>+91-8962813719</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Panel */}
            <div className="contact-form-panel">
              <div className="contact-form-topline"></div>

              <div className="contact-form-header">
                <div className="contact-form-icon">
                  <SendOutlined />
                </div>
                <h3>Send Us a Message</h3>
                <p>We usually respond as soon as possible</p>
              </div>

              <div className="contact-form-box">
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={OnSubmit}
                  className="contact-form"
                >
                  <Form.Item
                    name="name"
                    label="Your Name"
                    rules={[{ required: true, message: "Please enter your name" }]}
                  >
                    <Input
                      prefix={<UserOutlined />}
                      placeholder="Enter your name"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    name="email"
                    label="Your Email"
                    rules={[
                      { required: true, message: "Please enter your email" },
                      { type: "email", message: "Please enter a valid email" },
                    ]}
                  >
                    <Input
                      prefix={<MailOutlined />}
                      placeholder="Enter your email"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    name="mobile"
                    label="Your Mobile Number"
                    rules={[
                      { required: true, message: "Please enter your mobile number" },
                      {
                        pattern: /^[0-9]{10}$/,
                        message: "Mobile number must be 10 digits",
                      },
                    ]}
                  >
                    <Input
                      prefix={<PhoneOutlined />}
                      placeholder="Enter your mobile number"
                      size="large"
                      maxLength={10}
                    />
                  </Form.Item>

                  <Form.Item
                    name="message"
                    label="Message"
                    rules={[{ required: true, message: "Please enter your message" }]}
                  >
                    <Input.TextArea
                      rows={5}
                      placeholder="Write your message..."
                      className="contact-textarea"
                    />
                  </Form.Item>

                  <Form.Item style={{ marginBottom: 0 }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      block
                      className="contact-submit-btn"
                    >
                      <SendOutlined />
                      Send Message
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default Contact;